module.exports = __webpack_public_path__ + "img/dog-mating.f56c2cdf.png";